import $ from "jquery";
import PdfLightboxProxy from "@/components/proxy/PdfLightboxProxy.vue";
import { mountVueComponent } from "@/app";


$(".pdf-lightbox").each(function() {
  mountVueComponent(PdfLightboxProxy, this, { data: this.dataset });
});
